import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export const useBreakpoints = () => {
    const theme = useTheme()

    return {
        isMobile: useMediaQuery(theme.breakpoints.down('sm')),
        isTablet: useMediaQuery(theme.breakpoints.between('sm', 'md')),
        isDesktop: useMediaQuery(theme.breakpoints.up('md')),
    }
}